import { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router';
import parse from "html-react-parser"
import Store from '../Store/Store'
import Request from '../Request/Request'

import Center from "../App/Center"
import Row from "../Page/Row"
import Links from "../Page/Links"

import Intro from "../Cruise/Intro"
import Program from "../Cruise/Program"
import StartingPoint from "../Cruise/StartingPoint"
import Cabins from "../Cruise/Cabins"
import Booking from "../Cruise/Booking"
import BookingForm from "../Cruise/BookingForm"
import MoreInformation from "../Cruise/MoreInformation"

import LandingPage from "../Page/Landing"
import Header from "../App/Header"

function LinkButton( props ) {
    return (
        <Link to={ props.to } >
            <button
                className="button"
                //onClick={ e => setMore( !more ) }
            >
                { props.label }
            </button>
        </Link>
    )
}

function Footer( props ) {

    return <>

    <div 
        style={{ 
            width:'100%', boxSizing:'border-box', minHeight:100, background:'#000', 
            margin:0, padding:'50px 20px', 
            textAlign:'center',  
        }} 
    >

        { props.sessionValid 
          ? <Link to="/pages-update">
                <span className="footer-link" style={{ color:'#ffffff', cursor:'pointer' }} >
                    Manage Content
                </span>
            </Link>
          : <Link to="/login">
                <span className="footer-link" style={{ color:'#ffffff', cursor:'pointer'  }} >
                    Coscox Enterprises &copy; 2025
                </span>
            </Link>
        }

    </div>

    </>

}

export function ContentRow( props ) {

    const [ tmp, setTmp ] = useState( 0 )

    const a = props.row
    const i = props.index

    const sessionValid = props.sessionValid
    const categories = props.categories
    const category = props.categories && a.category_id && categories[ a.category_id ]

    const zoomedRowId = props.zoomedRowId
    const setZoomedRowId = props.setZoomedRowId

    const cruiseId = props.cruiseId
    const cruise = props.cruise
    const cruiseProps = { cruise, zoomedRowId, setZoomedRowId, tmp, setTmp }

    if ( cruiseId && !cruise ) return false // cruise not loaded yet

    //if ( zoomedRowId && zoomedRowId !== a.id ) return false

    if ( a.template === 'landingPage' ) return <LandingPage key={ a.title + i } { ...a } { ...cruiseProps } />
    else if ( a.template === 'spacer' ) return <Center key={ i } style={{ height:100 }} />
    else if ( a.template === 'header' ) return <Header key={ a.title + i } />
    else if ( a.template === 'footer' ) return <Footer key={ a.title + i } sessionValid={ sessionValid } />
    else if ( a.template === 'cruiseBookingForm' ) return <BookingForm { ...a } { ...cruiseProps } />
    else return <Row 
    	key={ a.title + i } 
        right={ ( i - 1 ) % 2 }
    	{ ...a } 
        { ...cruiseProps }
	>
        { a.title && <h1>{ a.title }</h1> }
        { a.content && a.content.length > 0 && <>{ parse( a.content || '' ) }</> }
        { a.template === 'linkButton' && <LinkButton to={ a.button_link || "" } label={ a.button_label || "Show More" } /> }
        { a.template === 'cruiseLinks' && <Links category={ category } /> }
        { a.template === 'cruiseIntro' && <Intro { ...cruiseProps } /> }
        { a.template === 'cruiseProgram' && <Program { ...cruiseProps } /> }
        { a.template === 'cruiseStartingPoint' && <StartingPoint { ...cruiseProps } /> }
        { a.template === 'cruiseCabins' && <Cabins { ...cruiseProps } /> }
        { a.template === 'cruiseBooking' && <Booking { ...cruiseProps } /> }
        { a.template === 'cruiseMoreInformation' && <MoreInformation { ...cruiseProps } /> }
    </Row>

}


export function TextRow( props ) {
    //console.log( 'TextRow', props )
    return <Center>
        <div className={ "two left" } style={{ alignItems:'start' }}  >
            <div className="half-text" >
                { props.title1 && <h1>{ props.title1 }</h1> }
                { props.content1 && props.content1.length > 0 && <>{ parse( props.content1 || '' ) }</> }
            </div>
            <div className="half-text" >
                { props.title2 && <h1>{ props.title2 }</h1> }
                { props.title2 && <h1>Huu</h1> }
                { props.content2 && props.content2.length > 0 && <>{ parse( props.content2 || '' ) }</> }
            </div>
        </div>
    </Center>
}

export default function Content( props ) {

    const sessionValid = props.sessionValid
    const categories = props.categories
    const cruiseId = props.cruiseId

    //const cruise = props.cruise

    //const [ tmp, setTmp ] = useState( false )
    const [ cruise, setCruise ] = useState( false )
    const [ zoomedRowId, setZoomedRowId ] = useState( false )

    useEffect(() => {
        if ( cruiseId !== null && cruiseId !== undefined ) {
            //console.log( 'CRUISE', cruiseId )
            Request.get( 'cruise/' + cruiseId, 
                result => { 
                    setCruise( result.data )
                    //setTmp( tmp + 1 )
                    //Store.set( 'cruise-' + cruiseId )
                } 
            )
        }
    }, [ cruiseId ] ) ;


    const commonProps = { cruiseId, cruise, sessionValid, categories, zoomedRowId, setZoomedRowId }

    // for two textContent columns in a row
    Store.set( 'content-row-first-column', false )

    return <> { props.data.map( ( row, index ) => {

        // two textContent columns in a row
        if ( row.template === 'textContent' ) {
            if ( !Store.get( 'content-row-first-column' ) ) {
                Store.set( 'content-row-first-column', row )
                return false
            } else {
                const row1 = Store.get( 'content-row-first-column' )
                Store.set( 'content-row-first-column', false )
                return <TextRow 
                    title1={ row1.title }
                    content1={ row1.content }
                    title2={ row.title }
                    content2={ row.content }
                />
            }
        }

        const rowProps = { row, index }
        return <ContentRow key={ index } { ...commonProps } { ...rowProps } />

    } ) } </>

}

